import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    fixed: "left",
    width: 70,
  },
  {
    title: "name",
    key: "name",
    dataIndex: "name",
    ellipsis: true,
    width: 100,
  },
  {
    title: "Revisione ogni",
    key: "inspectionMonths",
    dataIndex: "inspectionMonths",
    ellipsis: true,
    width: 100,
    render: x => x && `${x} mesi`
  },
];

export default function () {

  return (
    <SimpleTablePage
      resource="equipmentType"
      columns={columns}
    />
  );
}
